/* Common Imports */
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
/* Component Imports */
import { Typography } from "@material-ui/core";
import IconTextHeadingCard from "../../page-sections/eden/subcomponents/IconTextHeadingCard";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 1rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 1rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 1rem 72rem",
    },

    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  mainContainer: {
    padding: "2rem 8rem 2.5rem 8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "2rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
    },

    // padding: "2rem 0rem 2rem 0rem",
    width: "100%",
  },
  heading: {
    width: "100%",
    color: "#693471",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  subHeading: {
    margin: "0rem 0rem 0.5rem 0rem",
    width: "100%",
    color: "#202020",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "2rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.125rem",
      lineHeight: "1.5rem",
    },
  },
  column: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    gap: "1rem",
    margin: "2.5rem 0rem 2.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: "1rem",
      margin: "1rem 0rem 1rem 0rem",
    },
    [theme.breakpoints.only("lg")]: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
      flexWrap: "wrap",
      gap: "1.5rem",
      margin: "1rem 0rem 2.5rem 0rem",
    },
    "& > *": {
      flex: "1 1 calc(50% - 1.5rem)",
      boxSizing: "border-box",
    },
  },
  iconTextCard: {
    width: "100%",
    padding: "1.5rem 1.5rem 1.5rem 1.5rem",
    boxShadow: "0px 4px 18px 0px rgba(0, 0, 0, 0.05)",
    borderRadius: "1rem",
    border: "1px solid  rgba(0, 0, 0, 0.12)",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  reraLink: {
    textDecoration: "none",
    width: "100%",
    "&:hover": {
      textDecoration: "none",
    },
  },
}));

const ProjectDetailsSection = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      {/* <div className={classes.megaContainer}> */}
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <Typography
            variant="h6"
            component="span"
            className={classes.heading}
          >
            Project Details
          </Typography>
          <div className={classes.column}>
            <IconTextHeadingCard
              className={classes.iconTextCard}
              icon="/images/icons/heavie/singleproperty/land_area.svg"
              title="Total Land Area"
              description="12,150 Sqft"
            />
            <IconTextHeadingCard
              className={classes.iconTextCard}
              icon="/images/icons/heavie/singleproperty/building.svg"
              title="Total No of Units"
              description="28"
            />
            <IconTextHeadingCard
              className={classes.iconTextCard}
              icon="/images/icons/heavie/singleproperty/project_approval.svg"
              title="Project Approval"
              description="BBMP Approved"
            />
            <Link
              href="https://rera.karnataka.gov.in/viewAllProjects"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.reraLink}
            >
              <IconTextHeadingCard
                className={classes.iconTextCard}
                icon="/images/icons/heavie/singleproperty/rera.svg"
                title="RERA No"
                description="PRM/KA/RERA/1251/446/PR/210222/004725"
              />
            </Link>
          </div>
          {/* </div> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProjectDetailsSection;
